module.exports = __webpack_public_path__ + "static/media/staylinked.0e52f397.svg";